module.exports = __webpack_public_path__ + "assets/img/ailogo.493b2714.png";